export type TimelineActivityType =
  | 'lead_created'
  | 'lead_assigned'
  | 'conversion'
  | 'deal_created'
  | 'call'
  | 'followup'
  | 'call_history'
  | 'meeting'
  | 'recording'
  | 'note'
  | 'todo'
  | 'reminder'
  | 'quotation'
  | 'proforma'
  | 'invoice'
  | 'payment'

export interface TimelineActor {
  id: string
  name: string
  avatarUrl?: string
}

export interface TimelineActivity {
  id: string
  type: TimelineActivityType
  title: string
  detail: string
  at: string
  actor: TimelineActor | null
  source: 'lead' | 'deal' | 'system'
  link?: { kind: 'lead' | 'deal' | 'document'; id: string }
  upcoming?: boolean
  status?: string
}

export interface DealTeamMember extends TimelineActor {
  role: 'Primary' | 'Collaborator'
  activityCount: number
}

export interface TimelineDeal {
  id: string
  title: string
  client: string
  stage: string
  stageColor: string | null
  value: number
  probability: number
  closeDate: string | null
  owner: string | null
  assignedToUserId: string | null
  pinned: boolean
  activityCount: number
  lastActivityAt: string | null
  nextActivityAt: string | null
}

export interface TimelineStats {
  total: number
  inProgress: number
  won: number
  lost: number
}

export interface TimelineListResponse {
  stats: TimelineStats
  deals: TimelineDeal[]
  facets: {
    stages: Array<{ name: string; color: string; isWon: boolean; isLost: boolean }>
    employees: TimelineActor[]
  }
  total: number
}

export interface DealDocument {
  _id: string
  number: string
  requestType: 'quotation' | 'proforma' | 'invoice'
  status: string
  total?: number
  date?: string
  createdAt: string
  clientId?: string | null
  createdBy?: string | null
}

export interface DealSchedule {
  _id: string
  quotationId: string
  quotationNumber?: string
  milestones: Array<{
    milestoneNumber: number
    name: string
    percentage?: number
    status: string
    milestoneTotal?: number
    amountReceived?: number
    dueDate?: string | null
    payments?: Array<{ _id?: string; amount: number; paidAt?: string; referenceNo?: string }>
  }>
}

export interface DealTimelineDetail {
  deal: any
  lead: { id: string; name: string; company?: string; source?: string; status?: string } | null
  activities: TimelineActivity[]
  team: DealTeamMember[]
  documents: DealDocument[]
  schedules: DealSchedule[]
  canLogActivity: boolean
}

export interface TimelineFilters {
  search: string
  employee: string
  stage: string
  outcome: 'all' | 'open' | 'won' | 'lost'
  from: string
  to: string
  scope: 'all' | 'mine' | 'following'
}

export const EMPTY_FILTERS: TimelineFilters = {
  search: '',
  employee: '',
  stage: '',
  outcome: 'all',
  from: '',
  to: '',
  scope: 'all',
}
